<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <SelectInput
        :question="$t('mobile-app.question')"
        :selections="[
          {
            image: require('@/assets/empty.svg'),
            name: $t('mobile-app.none'),
            value: 'none'
          },
          {
            image: require('@/assets/ios-only.svg'),
            name: $t('mobile-app.apple'),
            value: 'apple'
          },
          // {
          //   image: require('@/assets/android-only.svg'),
          //   name: $t('mobile-app.android'),
          //   value: 'android'
          // },
          {
            image: require('@/assets/android-ios.svg'),
            name: $t('mobile-app.both'),
            value: 'both'
          },
        ]"
        :selected-value="mobileApp"
        :clicked-callback="onSelect"
      ></SelectInput>
      <a @click="$router.push(getPrevStepUrl(step, $i18n.locale))" class="back-btn"
        >{{ $t('back') }}</a
      >
    </div>
  </div>
</template>

<script>
import SelectInput from "../../components/SelectInput";
import { mapMutations } from "vuex";
import CalculatorHeading from "../../components/CalculatorHeading";
import { getStepIndex, redirectToUnselectedStepIfAny, getPrevStepUrl, getNextStepUrl } from "@/utils/steps.js";

export default {
  name: "Project",
  components: { CalculatorHeading, SelectInput },
  data() {
    return {
      step: getStepIndex("mobile-app"),
      getPrevStepUrl: getPrevStepUrl,
      mobileApp: this.$store.state.data.mobileApp
    };
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateMobileApp"]),
    onSelect(value) {
      this.mobileApp = value;
      this.updateMobileApp(value);
      setTimeout(() => this.$router.push(getNextStepUrl(this.step, this.$i18n.locale)), 200);
    }
  }
};
</script>
